import { render, staticRenderFns } from "./SwitcherView.vue?vue&type=template&id=45e4458a&scoped=true"
import script from "./SwitcherView.vue?vue&type=script&lang=js"
export * from "./SwitcherView.vue?vue&type=script&lang=js"
import style0 from "./SwitcherView.vue?vue&type=style&index=0&id=45e4458a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e4458a",
  null
  
)

export default component.exports